module.exports = __webpack_public_path__ + "img/4-7.10216831.png";